import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { UploadProps } from "@portal/BaseComponents/Upload/type";
import { Icon } from "@portal/lib/icons/icons";
import { DefaultFileUploaderProps, acceptInputAttr } from "../DocUploader";
import { StyledDragger } from "./style";
const t = {
  upload_files: "Upload File",
  desc: "Click or drop your files here",
  max_size: "Max file size: 20mb",
  title: {
    upload: "Upload File",
    uploaded: "Uploaded Files",
  },
};
const UploadIcon = (
  <Icon icon={["fal", "cloud-arrow-up"]} color="var(--primary-3)" size="2x" />
);
function UploadDragger<T>(props: DefaultFileUploaderProps<T>) {
  const defaultProps: UploadProps<T> = {
    name: props.name,
    multiple: true,
    action: props.action,
    accept: props.acceptInputAttr ?? acceptInputAttr,
    onChange: props.onChange,
    fileList: props.fileList,
    onRemove: props.onRemove,
    onPreview: props.onPreview,
    beforeUpload: props.beforeUpload,
    itemRender: props.itemRender,
    listType: "text",
  };
  const Header = (
    <Flex vertical>
      {UploadIcon}
      <TypographyText fs="14">{t.upload_files}</TypographyText>
    </Flex>
  );
  const Body = (
    <TypographyText fs="12" style={{ color: "var(--gray-7)" }}>
      {t.desc}
    </TypographyText>
  );
  const FileSizeInfo = (
    <TypographyText fs="12" style={{ color: "var(--gray-7)" }}>
      {t.max_size}
    </TypographyText>
  );
  const UploadDefaultInfo = (
    <Flex vertical space="8">
      {Header}
      {Body}
      {FileSizeInfo}
    </Flex>
  );
  const UploadArea = (
    <Flex justify="center" align="center">
      {UploadDefaultInfo}
    </Flex>
  );
  const DraggerHeader = (
    <Flex align="center" space="4">
      <TypographyText fs="12" strong>
        {t.title.uploaded}
      </TypographyText>
      <TypographyText fs="14" style={{ color: "var(--gray-7)" }}>
        {`(${props.fileList?.length})`}
      </TypographyText>
    </Flex>
  );

  return (
    <Flex vertical space="8" justify="center" align="center">
      {DraggerHeader}
      <StyledDragger {...defaultProps as any}>{UploadArea}</StyledDragger>
    </Flex>
  );
}

export { UploadDragger };
